import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/header";
import "./managecdbalance.css";

const ManageCDbalance = () => {
    const [policies, setPolicies] = useState([]);
    const [showCreateCdPopup, setShowCreateCdPopup] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [cdDate, setCdDate] = useState("");
    const [cdAmount, setCdAmount] = useState("");
    const [policyName, setPolicyName] = useState("");
    const [policyNumber, setPolicyNumber] = useState("");
        const [loadingOrg, setLoadingOrg] = useState(true);
    const [policyId, setPolicyId] = useState(null);
    const [showTrackPopup, setShowTrackPopup] = useState(false);
    const [trackData, setTrackData] = useState([]);
    const [receiptNo, setReceiptNo] = useState("");


    const [showInsurerPopup, setShowInsurerPopup] = useState(false);
    const [insurers, setInsurers] = useState([]);

    const [formData, setFormData] = useState({
        company_name: "",
        branch: "",
        insurer_name: "",
        insurer_email: "",
        insurer_phno: "",
        insurer_balance: "",
        account_no: "",
        date: ""
    });

    // -----------------------------
    // Fetch policies for org
    // -----------------------------
  
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            console.log("🔍 Logged User Details:", parsedUser);
        }
    }, []);

    useEffect(() => {
        if (showInsurerPopup) {
            fetch("/api/insurer-master")
                .then(res => res.json())
                .then(data => setInsurers(data))
                .catch(err => console.error(err));
        }
    }, [showInsurerPopup]);



    const fetchPolicies = async () => {
        try {
            const storedUser = JSON.parse(localStorage.getItem("user"));

            if (!storedUser || !storedUser.org_id) {
                setPolicies([]);
                return;
            }

            const orgId = storedUser.org_id;

            const res = await fetch(
                `/api/add_policyss?org_id=${orgId}`
            );

            if (!res.ok) throw new Error("Failed to fetch policies");

            const data = await res.json();

            const filtered = Array.isArray(data)
                ? data.filter(p => p.org_id === orgId)
                : [];

            setPolicies(filtered);
        } catch (err) {
            console.error("Error fetching policies:", err);
            setPolicies([]);
        }
    };
    useEffect(() => {
        fetchPolicies();
    }, []);


    // -----------------------------
    // Open Add CD Popup
    // -----------------------------
    const openAddPopup = (policy) => {
        setSelectedCompany(policy);
        setPolicyName(policy.policy_name || "");
        setPolicyNumber(policy.policy_number || "");
        setPolicyId(policy.policy_id); // ✅ use policy_id
        setShowCreateCdPopup(true);
    };


    const latestPolicies = Object.values(
        policies.reduce((acc, curr) => {
            const key = `${curr.company_name}_${curr.branch}`;

            if (!acc[key] || curr.policy_id > acc[key].policy_id) {
                acc[key] = curr;
            }

            return acc;
        }, {})
    );


   


    // -----------------------------
    // Track CD deposits
    // -----------------------------
    const openTrackPopup = async (policy) => {
        try {
            const res = await fetch(
                `/api/cdBalance/track/${policy.policy_id}`
            );

            const json = await res.json();

            if (!res.ok || !json.success) {
                throw new Error("Failed to load CD history");
            }

            setTrackData(json.data); // ✅ store all records
            setShowTrackPopup(true);
        } catch (err) {
            console.error("Track fetch failed", err);
            alert("Failed to load CD history");
        }
    };

// const handleAmountChange = (value) => {
//     let cleaned = value.replace(/[^0-9.]/g, "");

//     const parts = cleaned.split(".");
//     if (parts.length > 2) {
//         cleaned = parts[0] + "." + parts[1];
//     }

//     const [integer, decimal] = cleaned.split(".");

//     let formattedInt = integer;
//     if (integer) {
//         const lastThree = integer.slice(-3);
//         const otherNumbers = integer.slice(0, -3);

//         if (otherNumbers !== "") {
//             formattedInt =
//                 otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
//                 "," +
//                 lastThree;
//         }
//     }

//     const finalValue =
//         decimal !== undefined ? `${formattedInt}.${decimal}` : formattedInt;

//     setCdAmount(finalValue);
// };
    // -----------------------------
    // Save CD deposit
    // -----------------------------
    // const handleSaveCD = async () => {
    //     if (!cdAmount || !policyId) {
    //         alert("⚠️ Please fill all required fields.");
    //         return;
    //     }

    //     try {
    //         const storedUser = JSON.parse(localStorage.getItem("user"));
    //         const modifiedBy = storedUser?.user_name || "Unknown User";

    //         const response = await fetch("/api/cdBalance/add", {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({
    //                 policy_id: policyId,
    //                 deposit_amount: Number(cdAmount),
    //                 receipt_no: receiptNo || null,
    //                 cd_date: cdDate || null,
    //                 modified_by: modifiedBy
    //             })
    //         });

    //         const data = await response.json();

    //         if (!response.ok || !data.success) {
    //             throw new Error(data.message);
    //         }

    //         alert(`✅ CD updated! Remaining balance: ${data.updatedRemaining}`);

    //         // Clear popup
    //         setCdAmount("");
    //         setReceiptNo("");
    //         setCdDate("");
    //         setShowCreateCdPopup(false);

    //         // 🔥 Refresh policy list
    //         // inside handleSaveCD()
    //         fetchPolicies();

    //     } catch (err) {
    //         console.error("❌ Error saving CD balance:", err);
    //         alert(err.message || "Something went wrong");
    //     }
    // };

const handleAmountChange = (value) => {
    // Allow only numbers, dot and minus
    let cleaned = value.replace(/[^0-9.-]/g, "");

    // ✅ Handle minus only at start
    const isNegative = cleaned.startsWith("-");
    cleaned = cleaned.replace(/-/g, ""); // remove all minus
    if (isNegative) cleaned = "-" + cleaned;

    // ✅ Prevent multiple dots
    const parts = cleaned.split(".");
    if (parts.length > 2) {
        cleaned = parts[0] + "." + parts[1];
    }

    let [integer, decimal] = cleaned.split(".");

    // Remove minus for formatting
    let intPart = integer.replace("-", "");

    if (intPart) {
        const lastThree = intPart.slice(-3);
        const otherNumbers = intPart.slice(0, -3);

        if (otherNumbers !== "") {
            intPart =
                otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
                "," +
                lastThree;
        }
    }

    let formatted = decimal !== undefined ? `${intPart}.${decimal}` : intPart;

    // Add minus back
    if (isNegative) {
        formatted = "-" + formatted;
    }

    setCdAmount(formatted);
};




  const handleSaveCD = async () => {
    // ✅ Required check
    if (!cdAmount || !policyId) {
        alert("⚠️ Please fill all required fields.");
        return;
    }

    // ✅ DATE VALIDATION (current month)
    if (!cdDate) {
        alert("⚠️ Please select date");
        return;
    }

    const selected = new Date(cdDate);
    const now = new Date();

    if (
        selected.getMonth() !== now.getMonth() ||
        selected.getFullYear() !== now.getFullYear()
    ) {
        alert("⚠️ Date should be within current month");
        return;
    }

    // ✅ RECEIPT VALIDATION
    if (receiptNo && receiptNo.length > 15) {
        alert("⚠️ Receipt number should be max 15 characters");
        return;
    }

    // ✅ CLEAN AMOUNT (support minus + remove commas)
    const cleanedAmount = cdAmount.toString().replace(/,/g, "");

    // ❗ IMPORTANT: allow negative, just check valid number
    if (isNaN(cleanedAmount)) {
        alert("⚠️ Please enter valid amount");
        return;
    }

    try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const modifiedBy = storedUser?.user_name || "Unknown User";

        console.log("Sending Payload:", {
            policy_id: policyId,
            deposit_amount: Number(cleanedAmount),
            receipt_no: receiptNo,
            cd_date: cdDate
        });

        const response = await fetch("/api/cdBalance/add", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                policy_id: policyId,
                deposit_amount: Number(cleanedAmount), // ✅ supports negative
                receipt_no: receiptNo || null,
                cd_date: cdDate || null,
                modified_by: modifiedBy
            })
        });

        const data = await response.json();

        console.log("API Response:", data);

        if (!response.ok || !data.success) {
            throw new Error(data.message || "API failed");
        }

        alert(`✅ CD updated! Remaining balance: ${data.updatedRemaining}`);

        // ✅ Clear popup
        setCdAmount("");
        setReceiptNo("");
        setCdDate("");
        setShowCreateCdPopup(false);

        // ✅ Refresh list
        fetchPolicies();

    } catch (err) {
        console.error("❌ Error saving CD balance:", err);
        alert(err.message || "Something went wrong");
    }
};

    const handleSaveInsurer = async () => {
        const user = JSON.parse(localStorage.getItem("user"));

        const payload = {
            ...formData,
            org_id: user.org_id
        };

        const res = await fetch("/api/insurance-companies/add", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        });

        const data = await res.json();

        if (res.ok) {
            alert("✅ Insurer CD Balance Created");
            setShowInsurerPopup(false);
        } else {
            alert(data.message || "Failed");
        }
    };



    return (
        <div className="manage-cd-container">
            <aside className="sidebar">
                <Header />
            </aside>
            <main className="main-content">
              
                <div className="cd-top-bar">
                    <h2>Manage CD Balance</h2>

                    <button
                        className="btn btn-primary create-cd-btn"
                        onClick={() => setShowInsurerPopup(true)}
                    >
                        ➕ Create CD Balance
                    </button>

                </div>


                <table className="cd-table">
                    <thead>
                        <tr>
                            <th>Insurer Name</th>
                            <th>Branch</th>
                            <th>Pincode</th> 
                            <th>Opening Balance</th>
                            <th>Remaining CD Balance</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {latestPolicies.length > 0 ? (
                            latestPolicies.map((p) => (
                                <tr key={p.policy_id}>
                                    <td>{p.company_name}</td>
                                    <td>{p.branch}</td>
                                    <td>{p.pincode || "-"}</td>
                                    <td>{Number(p.cd_balance || 0).toLocaleString("en-IN")}</td>
<td>{Number(p.remaining_cd_balance || 0).toLocaleString("en-IN")}</td>
                                    <td>
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => openAddPopup(p)}
                                        >
                                            ➕ Add
                                        </button>

                                        <button
                                            className="btn btn-warning track-btn"
                                            onClick={() => openTrackPopup(p)}
                                            style={{ marginLeft: "8px" }}
                                        >
                                            📄 Track
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5">No policies found</td>
                            </tr>
                        )}
                    </tbody>
                </table>


                {/* ---------------- Add CD Popup ---------------- */}
                {/* {showCreateCdPopup && (
                    <div className="popup-overlay">
                        <div className="popup">
                            <h3>Create Cash Deposit</h3>

                            <label>Date:</label>
                            <input
                                type="date"
                                value={cdDate}
                                onChange={(e) => setCdDate(e.target.value)}
                            />

                            <label>Receipt No:</label>
                            <input
                                type="text"
                                value={receiptNo}
                                onChange={(e) => setReceiptNo(e.target.value)}
                            />

                            <label>Amount:</label>
                            <input
                                type="number"
                                value={cdAmount}
                                onChange={(e) => setCdAmount(e.target.value)}
                            />

                            <div className="popup-actions">
                                <button className="btn btn-secondary" onClick={() => setShowCreateCdPopup(false)}>
                                    Cancel
                                </button>
                                <button className="btn btn-primary" onClick={handleSaveCD}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )} */}

                {showCreateCdPopup && (
    <div className="popup-overlay">
        <div className="popup">
            <h3>Create Cash Deposit</h3>

            {/* DATE */}
            <label>Date:</label>
            <input
                type="date"
                value={cdDate}
                max={new Date().toISOString().split("T")[0]}
                min={new Date(new Date().getFullYear(), new Date().getMonth(), 1)
                    .toISOString()
                    .split("T")[0]}
                onChange={(e) => setCdDate(e.target.value)}
            />

            {/* RECEIPT */}
            <label>Receipt No:</label>
            <input
                type="text"
                value={receiptNo}
                maxLength={15}
                onChange={(e) => setReceiptNo(e.target.value)}
            />

            {/* AMOUNT */}
            <label>Amount:</label>
            <input
                type="text"
                value={cdAmount}
                placeholder="Enter amount (e.g. 15,00,000.00)"
                onChange={(e) => handleAmountChange(e.target.value)}
            />

            <div className="popup-actions">
                <button
                    className="btn btn-secondary"
                    onClick={() => setShowCreateCdPopup(false)}
                >
                    Cancel
                </button>

                <button
                    className="btn btn-primary"
                    onClick={handleSaveCD}
                >
                    Save
                </button>
            </div>
        </div>
    </div>
)}

                {/* ---------------- Track Popup ---------------- */}
                {showTrackPopup && (
                    <div className="trackpopup-overlay">
                        <div className="trackpopup-container">
                            <h3>Track CD Deposit History</h3>
                            {trackData.length === 0 ? (
                                <p>No CD Deposit records found.</p>
                            ) : (
                                <table className="track-table">
                                    <thead>
                                        <tr>
                                            <th>Receipt No</th>
                                            <th>Amount</th>
                                            <th>Modified By</th>
                                            <th>Modified Date</th>
                                        </tr>
                                    </thead>
                                        <tbody>
                                            {trackData.map((rec, idx) => (
                                                <tr key={idx}>
                                                    <td>{rec.receipt_no || "-"}</td>
                                                    <td>{rec.cd_amount?.toLocaleString()}</td>
                                                    <td>{rec.modified_by}</td>
                                                    <td>{new Date(rec.modified_date).toLocaleString()}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                </table>
                            )}
                            <button className="trackpopup-close-btn" onClick={() => setShowTrackPopup(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                )}

                {showInsurerPopup && (
                    <div className="popup-overlay">
                        <div className="popup large-popup">
                            <h3>Create Insurer CD Balance</h3>

                            <label>Insurer</label>
                            <select
                                value={formData.company_name}
                                onChange={(e) =>
                                    setFormData({ ...formData, company_name: e.target.value })
                                }
                            >
                                <option value="">Select Insurer</option>
                                {insurers.map((i) => (
                                    <option key={i.company_id} value={i.insurer}>
                                        {i.insurer}
                                    </option>
                                ))}
                            </select>

                            <label>Branch</label>
                            <input
                                type="text"
                                onChange={(e) =>
                                    setFormData({ ...formData, branch: e.target.value })
                                }
                            />

                            <label>Insurer Name</label>
                            <input
                                type="text"
                                onChange={(e) =>
                                    setFormData({ ...formData, insurer_name: e.target.value })
                                }
                            />

                            <label>Email</label>
                            <input
                                type="email"
                                onChange={(e) =>
                                    setFormData({ ...formData, insurer_email: e.target.value })
                                }
                            />

                            <label>Phone Number</label>
                            <input
                                type="text"
                                onChange={(e) =>
                                    setFormData({ ...formData, insurer_phno: e.target.value })
                                }
                            />

                            <label>Account Number</label>
                            <input
                                type="text"
                                onChange={(e) =>
                                    setFormData({ ...formData, account_no: e.target.value })
                                }
                            />

                            <label>Amount</label>
                            <input
                                type="number"
                                onChange={(e) =>
                                    setFormData({ ...formData, insurer_balance: e.target.value })
                                }
                            />

                            <label>Date</label>
                            <input
                                type="date"
                                onChange={(e) =>
                                    setFormData({ ...formData, date: e.target.value })
                                }
                            />

                            <div className="popup-actions">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowInsurerPopup(false)}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="btn btn-primary"
                                    onClick={handleSaveInsurer}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </main>
        </div>
    );
};

export default ManageCDbalance;
